module.exports = __webpack_public_path__ + "static/media/residential.d6eec688.png";